import { useEffect } from "react";
import { useApp } from "@/context/AppContext";

const LOCALES = { de: "de_AT", sl: "sl_SI", hr: "hr_HR" };

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useSeo(page, override = {}) {
  const { t, lang } = useApp();
  const s = (t.seo && t.seo[page]) || {};
  const title = override.title || s.title;
  const desc = override.desc || s.desc;
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
    }
    if (desc) {
      setMeta("name", "description", desc);
      setMeta("property", "og:description", desc);
    }
    setMeta("property", "og:locale", LOCALES[lang] || "de_AT");
  }, [title, desc, lang]);
}
